import { lazy } from 'react';

import { MinervaRoute } from 'src/utils/router';

export const NotFoundRoute: MinervaRoute<'404'> = {
  name: '404',
  path: '/:unknown_url',
  comp: () => lazy(() => import('./index')),

  activate: () => {
    // eslint-disable-next-line no-console
    console.log('activated 404 page');
  },
};
